import React, { useEffect, useState, useCallback } from "react";
import './Filtro2.css';
import { useNavigate, useParams } from "react-router-dom";
import { fetchAndFormatUbi, fetchAndFormatTipos, fetchAndFormatAmbientes } from "../../json/Datos";
import { Spinner } from 'react-bootstrap';

const FILTROS_INICIALES = {
  ubicacionSeleccionada: 'cualquiera',
  tipoPropiedadSeleccionada: 'cualquiera',
  ambientesSeleccionado: 'cualquiera',
  moneda: 'cualquiera',
  precioMin: '',
  precioMax: '',
  superficieMin: '',
  superficieMax: '',
  ocultarReservadas: false,
  inputValue: ''
};

const FiltroHome2 = (props) => {
  const navigate = useNavigate();
  const { categoriaId, busqueda } = useParams();

  const [ubicaciones, setUbicaciones] = useState([]);
  const [tiposPropiedades, setTiposPropiedades] = useState([]);
  const [ambientes, setAmbientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [panelAbierto, setPanelAbierto] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [ubicacionesData, tiposData, ambientesData] = await Promise.all([
          fetchAndFormatUbi(),
          fetchAndFormatTipos(),
          fetchAndFormatAmbientes()
        ]);
        setUbicaciones(ubicacionesData);
        setTiposPropiedades(tiposData);
        setAmbientes(ambientesData);
        setLoading(false);
      } catch (error) {
        console.error('Error al obtener ubicaciones/tipos/ambientes:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const [filtros, setFiltros] = useState({
    ...FILTROS_INICIALES,
    operacionSeleccionada: categoriaId
  });

  // Borrador de los campos numéricos: no se aplican tecla por tecla, solo
  // al confirmar (botón Aplicar / Enter), para no disparar un fetch por dígito.
  const [borrador, setBorrador] = useState({
    precioMin: '',
    precioMax: '',
    superficieMin: '',
    superficieMax: ''
  });

  const enviarResultados = useCallback((resultados) => {
    props.enviarResultados(resultados);
    let ruta;
    if (resultados.operacionSeleccionada === 'cualquiera') {
      ruta = '/propiedades';
    } else if (resultados.operacionSeleccionada === "Ventas") {
      ruta = '/propiedades/ventas';
    } else if (resultados.operacionSeleccionada === "Alquileres") {
      ruta = '/propiedades/alquileres';
    } else {
      ruta = '/propiedades';
    }

    navigate(ruta);
  }, [props, navigate]);

  useEffect(() => {
    const operacionFromURL = categoriaId === "ventas" ? "Ventas" : categoriaId === "alquileres" ? "Alquileres" : "cualquiera";
    const buscador = busqueda !== undefined ? busqueda : '';
    setFiltros(prevFiltros => ({
      ...prevFiltros,
      inputValue: buscador,
      operacionSeleccionada: operacionFromURL
    }));
  }, [categoriaId, busqueda]);

  const aplicarFiltro = () => {
    enviarResultados(filtros);
  };

  // Los selects y el checkbox aplican el filtro al toque; los campos
  // numéricos (precio/superficie) se aplican con el botón Aplicar o Enter.
  const cambiarYAplicar = (campo, valor) => {
    const nuevosFiltros = { ...filtros, [campo]: valor };
    setFiltros(nuevosFiltros);
    enviarResultados(nuevosFiltros);
  };

  const handleOperacionChange = (valor) => cambiarYAplicar('operacionSeleccionada', valor);
  const handleUbicacionChange = (event) => cambiarYAplicar('ubicacionSeleccionada', event.target.value);
  const handleTipoPropiedadChange = (event) => cambiarYAplicar('tipoPropiedadSeleccionada', event.target.value);
  const handleAmbientesChange = (event) => cambiarYAplicar('ambientesSeleccionado', event.target.value);
  const handleMonedaChange = (event) => cambiarYAplicar('moneda', event.target.value);
  const handleOcultarReservadasChange = (event) => cambiarYAplicar('ocultarReservadas', event.target.checked);

  const handleInputChange = (event) => {
    const inputValue = event.target.value || '';
    setFiltros({ ...filtros, inputValue });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      aplicarFiltro();
    }
  };

  const handleBorradorChange = (campo) => (event) => {
    setBorrador({ ...borrador, [campo]: event.target.value });
  };

  const aplicarRangos = () => {
    const nuevosFiltros = { ...filtros, ...borrador };
    setFiltros(nuevosFiltros);
    enviarResultados(nuevosFiltros);
    setPanelAbierto(false);
  };

  const handleRangoKeyPress = (event) => {
    if (event.key === "Enter") {
      aplicarRangos();
    }
  };

  const limpiarFiltros = () => {
    const nuevosFiltros = { ...FILTROS_INICIALES, operacionSeleccionada: filtros.operacionSeleccionada };
    setFiltros(nuevosFiltros);
    setBorrador({ precioMin: '', precioMax: '', superficieMin: '', superficieMax: '' });
    enviarResultados(nuevosFiltros);
  };

  // Chips de filtros activos, cada uno con su propio botón de limpiar.
  const chips = [];
  if (filtros.ubicacionSeleccionada !== 'cualquiera') {
    chips.push({ key: 'ubicacionSeleccionada', label: filtros.ubicacionSeleccionada, reset: 'cualquiera' });
  }
  if (filtros.tipoPropiedadSeleccionada !== 'cualquiera') {
    chips.push({ key: 'tipoPropiedadSeleccionada', label: filtros.tipoPropiedadSeleccionada, reset: 'cualquiera' });
  }
  if (filtros.ambientesSeleccionado !== 'cualquiera') {
    const amb = ambientes.find((a) => a.codigo === filtros.ambientesSeleccionado);
    chips.push({ key: 'ambientesSeleccionado', label: amb ? amb.descripcion : filtros.ambientesSeleccionado, reset: 'cualquiera' });
  }
  if (filtros.moneda !== 'cualquiera') {
    chips.push({ key: 'moneda', label: filtros.moneda === 'D' ? 'U$S' : '$', reset: 'cualquiera' });
  }
  if (filtros.precioMin || filtros.precioMax) {
    const label = `Precio: ${filtros.precioMin || '0'} - ${filtros.precioMax || '∞'}`;
    chips.push({ key: 'precio', label, reset: null });
  }
  if (filtros.superficieMin || filtros.superficieMax) {
    const label = `Sup.: ${filtros.superficieMin || '0'} - ${filtros.superficieMax || '∞'} m²`;
    chips.push({ key: 'superficie', label, reset: null });
  }
  if (filtros.ocultarReservadas) {
    chips.push({ key: 'ocultarReservadas', label: 'Sin reservadas', reset: false });
  }

  const quitarChip = (chip) => {
    if (chip.key === 'precio') {
      const nuevosFiltros = { ...filtros, precioMin: '', precioMax: '' };
      setBorrador({ ...borrador, precioMin: '', precioMax: '' });
      setFiltros(nuevosFiltros);
      enviarResultados(nuevosFiltros);
      return;
    }
    if (chip.key === 'superficie') {
      const nuevosFiltros = { ...filtros, superficieMin: '', superficieMax: '' };
      setBorrador({ ...borrador, superficieMin: '', superficieMax: '' });
      setFiltros(nuevosFiltros);
      enviarResultados(nuevosFiltros);
      return;
    }
    cambiarYAplicar(chip.key, chip.reset);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className="filtro-container">
      <div className="mt-4">
        <div className="row justify-content-center">
          <div className="col">
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={filtros.inputValue}
                onChange={handleInputChange}
                placeholder="Buscar..."
                onKeyPress={handleKeyPress}
              />
              <button className="btn btn-bordo" type="button" onClick={aplicarFiltro}>Buscar</button>
            </div>
          </div>
        </div>

        <div className="filtros-barra">
          <div className="operacion-switch">
            <button
              type="button"
              className={filtros.operacionSeleccionada === 'cualquiera' ? 'activo' : ''}
              onClick={() => handleOperacionChange('cualquiera')}
            >
              Cualquiera
            </button>
            <button
              type="button"
              className={filtros.operacionSeleccionada === 'Alquileres' ? 'activo' : ''}
              onClick={() => handleOperacionChange('Alquileres')}
            >
              Alquiler
            </button>
            <button
              type="button"
              className={filtros.operacionSeleccionada === 'Ventas' ? 'activo' : ''}
              onClick={() => handleOperacionChange('Ventas')}
            >
              Venta
            </button>
          </div>

          <button type="button" className="btn-filtros-toggle" onClick={() => setPanelAbierto(true)}>
            Filtros {chips.length > 0 && <span className="filtros-contador">{chips.length}</span>}
          </button>
        </div>
      </div>

      {panelAbierto && (
        <div className="filtros-overlay" onClick={() => setPanelAbierto(false)}>
          <div className="filtros-drawer" onClick={(e) => e.stopPropagation()}>
            <div className="filtros-panel">
              <div className="filtros-panel-header">
                <span>Filtros</span>
                <button type="button" className="filtros-cerrar" onClick={() => setPanelAbierto(false)} aria-label="Cerrar filtros">×</button>
              </div>

              {chips.length > 0 && (
                <div className="filtros-chips">
                  {chips.map((chip) => (
                    <button key={chip.key} type="button" className="chip" onClick={() => quitarChip(chip)}>
                      {chip.label} <span aria-hidden="true">×</span>
                    </button>
                  ))}
                  <button type="button" className="chip chip-limpiar" onClick={limpiarFiltros}>Limpiar todo</button>
                </div>
              )}

              <div className="filtro-campo">
                <label htmlFor="ubicacion">Ubicación</label>
                <select id="ubicacion" className="form-select" value={filtros.ubicacionSeleccionada} onChange={handleUbicacionChange}>
                  <option value="cualquiera">Cualquiera</option>
                  {ubicaciones.map((ubi, index) => (
                    <option key={index} value={ubi.descripcion}>{ubi.descripcion}</option>
                  ))}
                </select>
              </div>

              <div className="filtro-campo">
                <label htmlFor="tipoPropiedad">Tipo de propiedad</label>
                <select id="tipoPropiedad" className="form-select" value={filtros.tipoPropiedadSeleccionada} onChange={handleTipoPropiedadChange}>
                  <option value="cualquiera">Cualquiera</option>
                  {tiposPropiedades.map((tipo, index) => (
                    <option key={index} value={tipo.descripcion}>{tipo.descripcion}</option>
                  ))}
                </select>
              </div>

              <div className="filtro-campo">
                <label htmlFor="ambientes">Ambientes</label>
                <select id="ambientes" className="form-select" value={filtros.ambientesSeleccionado} onChange={handleAmbientesChange}>
                  <option value="cualquiera">Cualquiera</option>
                  {ambientes.map((amb) => (
                    <option key={amb.codigo} value={amb.codigo}>{amb.descripcion}</option>
                  ))}
                </select>
              </div>

              <div className="filtro-campo">
                <label>Precio</label>
                <div className="filtro-rango">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Mín."
                    value={borrador.precioMin}
                    onChange={handleBorradorChange('precioMin')}
                    onKeyPress={handleRangoKeyPress}
                  />
                  <span className="filtro-rango-guion">–</span>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Máx."
                    value={borrador.precioMax}
                    onChange={handleBorradorChange('precioMax')}
                    onKeyPress={handleRangoKeyPress}
                  />
                </div>
                <select className="form-select mt-2" value={filtros.moneda} onChange={handleMonedaChange}>
                  <option value="cualquiera">Cualquier moneda</option>
                  <option value="P">Pesos ($)</option>
                  <option value="D">Dólares (U$S)</option>
                </select>
              </div>

              <div className="filtro-campo">
                <label>Superficie (m²)</label>
                <div className="filtro-rango">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Mín."
                    value={borrador.superficieMin}
                    onChange={handleBorradorChange('superficieMin')}
                    onKeyPress={handleRangoKeyPress}
                  />
                  <span className="filtro-rango-guion">–</span>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Máx."
                    value={borrador.superficieMax}
                    onChange={handleBorradorChange('superficieMax')}
                    onKeyPress={handleRangoKeyPress}
                  />
                </div>
              </div>

              <div className="filtro-campo filtro-checkbox">
                <label htmlFor="ocultarReservadas">
                  <input
                    id="ocultarReservadas"
                    type="checkbox"
                    checked={filtros.ocultarReservadas}
                    onChange={handleOcultarReservadasChange}
                  />
                  Ocultar reservadas / no disponibles
                </label>
              </div>

              <div className="filtros-panel-acciones">
                <button type="button" className="btn btn-bordo flex-grow-1" onClick={aplicarRangos}>Aplicar</button>
                <button type="button" className="btn btn-outline-light" onClick={limpiarFiltros}>Limpiar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FiltroHome2;
